import React from "react";
import { Page } from "../../components/styled";
import PowerLeaderboard from "./powerLeaderboard";
import PvpLeaderboard from "./pvpleaderboard";
import SwipeableTabs from "../../components/shared/swipeableTabs";

const Leaderboard = () => {



    return (
        <Page>
            <SwipeableTabs tabs={["Power", "Pvp"]}>
                <PowerLeaderboard/>
                <PvpLeaderboard/>
            </SwipeableTabs>
        </Page>
    )
};


export default Leaderboard;